import { useLang } from 'hooks/lang';

import { ProjectMinFee } from 'entities';

import { Column, LabeledCheckbox } from 'components/Blocks';
import { DollarBillIcon } from 'components/Icons';
import { MonetaryInput } from 'components/Inputs';

import { CreateProjectDispatchAction } from '../types';

interface MinFeeProps {
  minFee?: ProjectMinFee;
  currency: string;
  dispatch: CreateProjectDispatchAction;
}

export function MinFee({ minFee, currency, dispatch }: MinFeeProps): JSX.Element {
  const { t } = useLang();

  const toggleMinFee = (): void => {
    dispatch({ minFee: (old) => (old.minFee ? undefined : { currency, value: '0' }) });
  };

  const handleMinFeeChange = (value: string): void => {
    dispatch({ minFee: (old) => ({ ...(old.minFee as ProjectMinFee), value }) });
  };

  return (
    <Column>
      <LabeledCheckbox
        checked={!!minFee}
        onChange={toggleMinFee}
        label={t('min-fee')}
        labelIcon={DollarBillIcon}
      />

      {minFee && (
        <MonetaryInput
          onChangeDirect={handleMinFeeChange}
          value={minFee.value}
          currencyDisabled
          currency={currency}
          required
        />
      )}
    </Column>
  );
}
